module.exports = { src: __webpack_public_path__ + "media/tile-5-image.8a29a8b2.webp", width: 540, height: 375 };